import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import L from 'leaflet';
import { PropTypes as LeafletPropTypes, MapControl } from 'react-leaflet';
import 'leaflet.polylinemeasure';
import 'leaflet.polylinemeasure/Leaflet.PolylineMeasure.css';

export class MeasureDistanceComponent extends MapControl {
  componentWillReceiveProps() {
    this.leafletElement._toggleMeasure();
  }

  componentDidMount() {
    super.componentDidMount();
    if (this.leafletElement) {
      this.leafletElement._container.style.display = 'none';
    }
  }

  createLeafletElement() {
    return L.control.polylineMeasure({
      imperial: true,
    });
  }

  render() {
    return null;
  }
}

MeasureDistanceComponent.propTypes = {
  measure: PropTypes.bool.isRequired,
};

MeasureDistanceComponent.contextTypes = {
  map: LeafletPropTypes.map,
};

/* istanbul ignore next */
export const mapStateToProps = state => {
  return {
    measure: state.measure,
  };
};

export default connect(mapStateToProps)(MeasureDistanceComponent);



// WEBPACK FOOTER //
// ./src/components/Map/MeasureDistance.js